import { getCookieConsent } from "@/lib/consent";
import { getUtm } from "@/lib/utm";
import { API } from "@/lib/api";

const rid = () => (crypto.randomUUID ? crypto.randomUUID().replace(/-/g, "") : `${Date.now()}${Math.random().toString(36).slice(2)}`);

const sid = () => {
  let s = sessionStorage.getItem("pp_sid");
  if (!s) { s = rid(); sessionStorage.setItem("pp_sid", s); }
  return s;
};

const vid = () => {
  if (!getCookieConsent()?.analytics) return null;
  let v = localStorage.getItem("pp_vid");
  if (!v) { v = rid(); localStorage.setItem("pp_vid", v); }
  return v;
};

const FB = { lead_submit: "Lead", apply_click: "InitiateCheckout" };

export const track = (name, params = {}) => {
  try {
    const clean = Object.fromEntries(Object.entries(params).filter(([, v]) => v != null && v !== "").map(([k, v]) => [k, String(v)]));
    const utm = getUtm();
    const body = JSON.stringify({ name, path: window.location.pathname, sid: sid(), vid: vid(), ref: utm.referrer || "", utm, params: clean });
    const url = `${API}/t`;
    if (!(navigator.sendBeacon && navigator.sendBeacon(url, new Blob([body], { type: "application/json" })))) {
      fetch(url, { method: "POST", body, headers: { "Content-Type": "application/json" }, keepalive: true }).catch(() => {});
    }
    if (name === "page_view") return;
    if (window.gtag) window.gtag("event", name, clean);
    if (window.dataLayer) window.dataLayer.push({ event: name, ...clean });
    if (window.fbq) window.fbq(FB[name] ? "track" : "trackCustom", FB[name] || name, clean);
  } catch {
    /* tracking must never break the UI */
  }
};

export const trackClicks = (links = {}) => (e) => {
  const el = e.target.closest?.("a, button");
  if (!el) return;
  const href = el.getAttribute("href") || "";
  const tid = el.getAttribute("data-testid") || "";
  if (/wa\.me|whatsapp\.com/i.test(href)) track("whatsapp_click", { href: href.slice(0, 100), id: tid });
  const partner = [links.partner_registration, links.partner_login, links.own_brand_agency].filter((l) => l && l !== "#");
  if (/partner/i.test(tid) || (href && partner.includes(href))) track("partner_click", { id: tid });
  if (/^blog-(cta|bottom|calc-apply|sidebar-full)/.test(tid)) track("blog_cta_click", { id: tid, path: window.location.pathname });
};
